import React, { Component } from "react";
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
    Alert,
    CircularProgress,
    CardMedia
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { singlePost, update } from "./apiPost";
import { isAuthenticated } from "../auth";
import { Redirect } from "react-router-dom";
import DefaultPost from "../images/mountains.jpg";

class EditPost extends Component {
    constructor() {
        super();
        this.state = {
            id: "",
            title: "",
            body: "",
            redirectToProfile: false,
            error: "",
            fileSize: 0,
            loading: false
        };
    }

    init = postId => {
        singlePost(postId).then(data => {
            if (data.error) {
                this.setState({ redirectToProfile: true });
            } else {
                this.setState({
                    id: data.postedBy._id,
                    title: data.title,
                    body: data.body,
                    error: ""
                });
            }
        });
    };

    componentDidMount() {
        this.postData = new FormData();
        const postId = this.props.match.params.postId;
        this.init(postId);
    }

    isValid = () => {
        const { title, body, fileSize } = this.state;
        if (fileSize > 1000000) {
            this.setState({
                error: "File size should be less than 100kb",
                loading: false
            });
            return false;
        }
        if (title.length === 0 || body.length === 0) {
            this.setState({ error: "All fields are required", loading: false });
            return false;
        }
        return true;
    };

    handleChange = name => event => {
        this.setState({ error: "" });
        const value =
            name === "photo" ? event.target.files[0] : event.target.value;

        const fileSize = name === "photo" ? event.target.files[0].size : 0;
        this.postData.set(name, value);
        this.setState({ [name]: value, fileSize });
    };

    clickSubmit = event => {
        event.preventDefault();
        this.setState({ loading: true });

        if (this.isValid()) {
            const postId = this.props.match.params.postId;
            const token = isAuthenticated().token;

            update(postId, token, this.postData).then(data => {
                if (data.error) this.setState({ error: data.error });
                else {
                    this.setState({
                        loading: false,
                        title: "",
                        body: "",
                        redirectToProfile: true
                    });
                }
            });
        }
    };

    editPostForm = (title, body) => (
        <Box component="form" sx={{ mt: 2 }}>
            <Box sx={{ mb: 2 }}>
                <input
                    onChange={this.handleChange("photo")}
                    type="file"
                    accept="image/*"
                    style={{ display: 'none' }}
                    id="photo-upload"
                />
                <label htmlFor="photo-upload">
                    <Button
                        variant="outlined"
                        component="span"
                        startIcon={<UploadFileIcon />}
                        fullWidth
                    >
                        {this.state.photo ? this.state.photo.name : 'Change Post Photo'}
                    </Button>
                </label>
            </Box>

            <TextField
                fullWidth
                label="Title"
                onChange={this.handleChange("title")}
                type="text"
                value={title}
                margin="normal"
                variant="outlined"
            />

            <TextField
                fullWidth
                label="Body"
                onChange={this.handleChange("body")}
                multiline
                rows={6}
                value={body}
                margin="normal"
                variant="outlined"
            />

            <Button
                onClick={this.clickSubmit}
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
            >
                Update Post
            </Button>
        </Box>
    );

    render() {
        const {
            id,
            title,
            body,
            redirectToProfile,
            error,
            loading
        } = this.state;

        if (redirectToProfile) {
            return <Redirect to={`/user/${isAuthenticated().userId}`} />;
        }

        return (
            <Container>
                <Typography variant="h4" sx={{ mt: 5, mb: 5 }}>
                    {title}
                </Typography>

                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}

                {loading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                        <Box sx={{ textAlign: 'center' }}>
                            <CircularProgress sx={{ mb: 2 }} />
                            <Typography variant="h6">Loading...</Typography>
                        </Box>
                    </Box>
                )}

                <CardMedia
                    component="img"
                    height="200"
                    image={`${process.env.REACT_APP_API_URL}/post/photo/${id}?${new Date().getTime()}`}
                    alt={title}
                    onError={(e) => {
                        e.target.src = DefaultPost;
                    }}
                    sx={{ width: 'auto', mb: 3, objectFit: 'contain' }}
                />

                {(isAuthenticated().role === "admin" || isAuthenticated().userId === id) &&
                    this.editPostForm(title, body)}
            </Container>
        );
    }
}

export default EditPost;